import React from 'react';
import classNames from 'classnames';

import './widget-opening-carousel-basic.scss';

const WidgetOpeningCarouselBasic: React.FC<any> = props => (
    <div
        className={classNames({
            'react-multi-carousel-list': true,
            'w-opening-carousel__list': true
        })}
    >
        <ul className="react-multi-carousel-track">
            {
                React.Children.map(props.children, child => (
                    <li
                        className={classNames({
                            'react-multi-carousel-item': true,
                            'w-opening-carousel__list__item': true
                        })}
                    >
                        {child}
                    </li>
                ))
            }
        </ul>
    </div>
);

export default WidgetOpeningCarouselBasic;
